import { makeStyles, Typography } from '@material-ui/core';
import React from 'react'
import { newLineToDiv, parseJwtPayload } from '../../utils/utils'

export interface PaymentFailInfoProps {
    productId: string,
    productType: string,
}

const useStyles = makeStyles((theme) => ({
    paymentFailBox: {
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        textAlign: 'center',
        flexFlow: 'column',
        backgroundColor: 'rgba(255, 111, 80, 0.08)',
        padding: '24px 16px 24px 16px',
    },
    apologizeImage: {
        height: '100px',
    },
    copyrightText: {
        marginTop: '8px',
        color: theme.greyscaleColorTheme.grey2.main,
    },
    apologizeText: {
        marginTop: '20px',
        color: theme.greyscaleColorTheme.darkGrey.main,
    },
    errorDescriptionText: {
        marginTop: '16px',
        color: theme.greyscaleColorTheme.grey2.main,
        ...theme.customTypography.body3,
    },
    emailDescription: {
        marginTop: '24px',
        color: theme.greyscaleColorTheme.grey2.main,
        ...theme.customTypography.body3,
    },
    paymentInfoBox: {
        height: '140px',
        marginTop: '24px',
        padding: '16px',
        alignContent: 'center',
        border: `0.5px solid ${theme.greyscaleColorTheme.lightGrey3.main}`,
        backgroundColor: theme.greyscaleColorTheme.white.main,
    },
    paymentInfoText: {
        textAlign: 'left',
        color: theme.brandColorTheme.orange.main,
    },
}))

function PaymentFailInfo(props: PaymentFailInfoProps) {
    const classes = useStyles()

    const apologizeText = newLineToDiv(`We are very sorry\nfor the inconvenience`)
    const errorDescriptionText = newLineToDiv(`An error occurred during product payment.\nWe know it's a hassle, but if you contact me in the\nfollowing ways, I'll help you as soon as possible.`)
    const emailDescriptionText = newLineToDiv(`Please capture the screen and send it to\nmojitok@platfarm.net`)
    const accessToken = sessionStorage.getItem('token')
    const customerID = accessToken ? parseJwtPayload(accessToken)["userId"] : ""
    const productID = props.productId
    const paymentPlatform = sessionStorage.getItem('paymentType')
    const productType = props.productType


    return (
        <div className={classes.paymentFailBox}>
            <img className={classes.apologizeImage} src={require('../../img/payment-fail.svg')} />
            <Typography className={classes.copyrightText} variant='caption'>© lamda</Typography>
            <Typography className={classes.apologizeText} variant='h4'>{apologizeText}</Typography>
            <Typography className={classes.errorDescriptionText}>{errorDescriptionText}</Typography>
            <div className={classes.paymentInfoBox}>
                <Typography className={classes.paymentInfoText} variant='subtitle2'>Customer ID:</Typography>
                <Typography className={classes.paymentInfoText} style={{ marginTop: '4px' }} variant='subtitle2'>[{customerID}]</Typography>
                <Typography className={classes.paymentInfoText} style={{ marginTop: '8px' }} variant='subtitle2'>Product ID:</Typography>
                <Typography className={classes.paymentInfoText} style={{ marginTop: '4px' }} variant='subtitle2'>[{productID}]</Typography>
                <Typography className={classes.paymentInfoText} style={{ marginTop: '8px' }} variant='subtitle2'>Payment platform: {paymentPlatform}</Typography>
                <Typography className={classes.paymentInfoText} style={{ marginTop: '4px' }} variant='subtitle2'>Product Type: {productType}</Typography>
            </div>
            <Typography className={classes.emailDescription}>{emailDescriptionText}</Typography>
        </div>
    )
}

export default PaymentFailInfo;